export const getStartEndTime = (timeInterval) => {
  const [startTime, endTime] = timeInterval.replace(/\s/g, '').split('-');

  return {
    startTime,
    endTime
  };
};
